/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Resolved filters represented by one audit response.
 */
export type RoadmapAuditFindingSelection = {
    timeframe: string;
    quarter: string;
    scope_key?: (string | null);
    group_ids?: Array<string>;
    assignee: RoadmapAuditFindingSelection.assignee;
    assignee_keys?: Array<string>;
    assignee_scope_employee_id?: (string | null);
    rule_ids?: Array<string>;
    rule_mode: RoadmapAuditFindingSelection.rule_mode;
    statuses?: Array<string>;
    query?: (string | null);
};

export namespace RoadmapAuditFindingSelection {

    export enum assignee {
        ALL = 'all',
        ME = 'me',
    }

    export enum rule_mode {
        ANY = 'any',
        ALL = 'all',
    }


}

